import { useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";

export const usePendingTimesheet = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const ref = useRef(null);
    const [userOptions, setUserOptions] = useState([]);

    useEffect(() => {
        callautopopulate("users").then(res => {
            setUserOptions(_.sortBy(res?.users, "user_display_name")?.map(item => { return { ...item, label: item?.user_display_name, value: item?.user_code } }));
        })
    }, [])

    const headerTemplate = (options, key) => {
        return (
            <div className="d-flex gap-1" style={{ cursor: 'pointer' }} onClick={options.onClick} >
                <span className="white-space-nowrap mb-1" style={{ fontSize: 'small', fontWeight: 500 }}>{key}</span>
            </div>
        );
    };

    return useMemo(() => ({
        ref, headerTemplate, activeIndex, setActiveIndex, userOptions
    }), [ref, headerTemplate, activeIndex, setActiveIndex, userOptions])
}